module.exports = __webpack_public_path__ + "static/media/registrationP.0c54f0ef.jpg";